// Deliberately free of React and Mantine imports so the conventions can be unit-tested
// directly. The functions that show notifications live in `notify.tsx`.

export type NotifyType = 'default' | 'error' | 'info' | 'success' | 'warning'

// Icons resolve to a key rather than JSX; `notify.tsx` maps each key to a component.
export type NotifyIconKey = 'check' | 'info' | 'warning' | 'x'

export interface NotificationStyle {
  color: string
  iconKey: NotifyIconKey | null
  autoClose: number | false
}

// Matches the react-toastify helpers this replaces: `displayToast` closed after 5000 ms,
// while `displayToastError` stayed open until dismissed. A single shared default would
// silently change one or the other.
const STYLES: Record<NotifyType, NotificationStyle> = {
  error: {
    color: 'red',
    iconKey: 'x',
    autoClose: false,
  },
  success: {
    color: 'green',
    iconKey: 'check',
    autoClose: 5000,
  },
  info: {
    color: 'blue',
    iconKey: 'info',
    autoClose: 5000,
  },
  warning: {
    color: 'yellow',
    iconKey: 'warning',
    autoClose: 5000,
  },
  default: {
    color: 'gray',
    iconKey: null,
    autoClose: 5000,
  },
}

export const resolveNotification = (
  type: NotifyType,
  overrides?: { autoClose?: number | false },
): NotificationStyle => {
  const style = STYLES[type] ?? STYLES.default

  // `??` rather than `||`, so an explicit `autoClose: 0` still wins.
  return {
    ...style,
    autoClose: overrides?.autoClose ?? style.autoClose,
  }
}
